import styles from "./Achievements.module.css";
import {
  FaTrophy,
  FaGraduationCap,
  FaNewspaper,
  FaGlobe,
  FaMedal,
  FaHandshake,
} from "react-icons/fa";
import { useState, useEffect, useCallback, useMemo } from "react";
import stemorg from "../../assets/images/achivements/stemx-org.png";
import atalInnovation from "../../assets/images/achivements/atal-innovatino-mission-white-bgr.jpg";
import lego from "../../assets/images/achivements/STEMx-LEGO-accreditation-update.png";
import microsoft from "../../assets/images/achivements/STEMx-ms-accreditation-update.png";
import mit from "../../assets/images/achivements/MIT-logo.png";
import stanford from "../../assets/images/achivements/stanford.jpg";
import tufts from "../../assets/images/achivements/Tufts-University-logo-1024x472.jpg";
import cambridge from "../../assets/images/achivements/University-of-Cambridge-stemx.png";
import oxford from "../../assets/images/achivements/University-of-Oxford-stemx.png";
import economicTimes from "../../assets/images/achivements/ecoomic-times.jpg";
import deccanCronicle from "../../assets/images/achivements/deccan-chronicle-1.jpg";
import timesOfIndia from "../../assets/images/achivements/times-of-india-500x500-1.png";
import nitiAyog from "../../assets/images/achivements/niti-aayog.jpg";
import businessStandard from "../../assets/images/achivements/business-standard.jpg";
import atalInnovationNews from "../../assets/images/achivements/atal-innovation-mission-1024x377.png";
import skillIndia from "../../assets/images/achivements/skillIndia.png";
import worldRobotOlympiad from "../../assets/images/achivements/world-robot-olympiad-stemx.png";
import IndiaRoboticLeague from "../../assets/images/achivements/india-robotics-league-stemxindia-more-300x187.jpg";
import IIT from "../../assets/images/achivements/IIT.png";
import award1 from "../../assets/images/achivements/awards/1.png";
import award2 from "../../assets/images/achivements/awards/2.png";
import award3 from "../../assets/images/achivements/awards/3.png";
import award4 from "../../assets/images/achivements/awards/4.png";
import award5 from "../../assets/images/achivements/awards/5.png";
import award6 from "../../assets/images/achivements/awards/6.png";
import award7 from "../../assets/images/achivements/awards/7.png";
const Achievements = () => {
  const sections = useMemo(
    () => [
      {
        id: "accreditation",
        icon: <FaTrophy />,
        title: "Accreditation",
        content: [
          {
            image: stemorg,
            name: "STEM.org from USA",
          },
          {
            image: atalInnovation,
            name: "Atal Innovation Mission",
          },
          { image: lego, name: "LEGO certified academy" },
          { image: microsoft, name: "Microsoft Qualified Institution" },
        ],
      },
      {
        id: "universities",
        icon: <FaGraduationCap />,
        title: "Our Students at Universities",
        content: [
          { image: mit, name: "MIT" },
          { image: stanford, name: "Stanford University" },
          { image: tufts, name: "Carnegie Mellon" },
          { image: cambridge, name: "Cambridge University" },
          { image: oxford, name: "Oxford University" },
          {
            image: IIT,
            name: "Indian Institute of Technology",
            subtext: "...and all other campuses",
          },
        ],
      },
      {
        id: "news",
        icon: <FaNewspaper />,
        title: "STEMx In News",
        content: [
          { image: economicTimes, name: "Featured in Economic Times" },
          { image: deccanCronicle, name: "Featured in Deccan Chronicle" },
          { image: timesOfIndia, name: "Featured in Times of India" },
          { image: nitiAyog, name: "Featured in Niti Aayog" },
          { image: businessStandard, name: "Featured in Business Standard" },
          {
            image: atalInnovationNews,
            name: "Featured in Atal Innovation Mission",
          },
        ],
      },
      {
        id: "competitions",
        icon: <FaGlobe />,
        title: "Global Competitions",
        content: [
          { image: skillIndia, name: "Skill India" },
          { image: worldRobotOlympiad, name: "World Robot Olympiad" },
          { image: IndiaRoboticLeague, name: "India Robotics League" },
        ],
      },
      {
        id: "awards",
        icon: <FaMedal />,
        title: "Awards & Recognition",
        content: [
          { image: award1, name: "Best EdTech Startup 2023" },
          { image: award2, name: "Innovation in STEM Education" },
          { image: award3, name: "Excellence in Teaching" },
          { image: award4, name: "Outstanding Contribution to Education" },
          { image: award5, name: "Best STEM Initiative" },
          { image: award6, name: "Innovative Teaching Practices" },
          { image: award7, name: "Leadership in Education" },
        ],
      },
    ],
    []
  );

  return (
    <section className={styles.achievements}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title} data-aos="fade-up">
            Our <span className={styles.highlight}>Achievements</span> &{" "}
            <span className={styles.highlight}>Recognition</span>
          </h2>
        </div>

        {sections.map((section, sectionIndex) => (
          <div key={section.id} className={styles.section} data-aos="fade-up">
            <div className={styles.sectionHeader}>
              <span className={styles.sectionIcon}>{section.icon}</span>
              <h3 className={styles.sectionTitle}>{section.title}</h3>
            </div>

            <div className={styles.grid}>
              {section.content.map((item, index) => (
                <div
                  key={index}
                  className={styles.card}
                  data-aos="fade-up"
                  data-aos-delay={index * 50}
                >
                  <div
                    className={styles.cardImage}
                    style={{
                      backgroundImage: `url(${item.image})`,
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                  {item.subtext && (
                    <div className={styles.cardSubtext}>{item.subtext}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className={styles.extra}>...and many more</div>
      </div>
    </section>
  );
};

export default Achievements;
